module.exports = __webpack_public_path__ + "img/icon_vipkpbj.870a0faa.png";